import { useState } from "react";
import API_BASE_URL from "../../config";

export default function UserActionMenu({ user, onActionComplete }) {
  const [open, setOpen]               = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState("");

  const handleBanToggle = async () => {
    setLoading(true);
    setError("");
    try {
      const token = localStorage.getItem('admin_token');
      const endpoint = user.isBanned
        ? `/api/admin/users/${user.id}/unban`
        : `/api/admin/users/${user.id}/ban`;
      
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(user.isBanned ? {} : { reason: "" })
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || "Action failed.");
      }

      onActionComplete();
    } catch (err) {
      setError(err.message || "Action failed.");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    setError("");
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch(`${API_BASE_URL}/api/admin/users/${user.id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || "Delete failed.");
      }

      onActionComplete();
    } catch (err) {
      setError(err.message || "Delete failed.");
    } finally {
      setLoading(false);
      setShowConfirm(false);
    }
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {/* ⋮ trigger */}
      <button
        onClick={() => setOpen(p => !p)}
        style={{
          background: "none", border: "none", cursor: "pointer",
          color: "#aaa", fontSize: 20, padding: "0 8px", lineHeight: 1
        }}
      >
        ⋮
      </button>

      {/* Dropdown */}
      {open && (
        <div style={{
          position: "absolute", right: 0, top: "100%", zIndex: 100,
          background: "#1a1a1a", border: "1px solid #333",
          borderRadius: 8, minWidth: 140, boxShadow: "0 4px 16px rgba(0,0,0,0.5)"
        }}>
          <button
            onClick={handleBanToggle}
            disabled={loading}
            style={{
              display: "block", width: "100%", textAlign: "left",
              padding: "10px 16px", background: "none", border: "none",
              color: user.isBanned ? "#6CD800" : "#f59e0b",
              cursor: "pointer", fontSize: 14
            }}
          >
            {user.isBanned ? "✓ Unban User" : "⊘ Ban User"}
          </button>
          <hr style={{ margin: 0, borderColor: "#333" }} />
          <button
            onClick={() => { setOpen(false); setShowConfirm(true); }}
            style={{
              display: "block", width: "100%", textAlign: "left",
              padding: "10px 16px", background: "none", border: "none",
              color: "#ef4444", cursor: "pointer", fontSize: 14
            }}
          >
            🗑 Delete User
          </button>
        </div>
      )}

      {/* Click-outside overlay */}
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{ position: "fixed", inset: 0, zIndex: 99 }}
        />
      )}

      {/* Delete confirmation modal */}
      {showConfirm && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 200,
          background: "rgba(0,0,0,0.7)", display: "flex",
          alignItems: "center", justifyContent: "center"
        }}>
          <div style={{
            background: "#1a1a1a", border: "1px solid #ef4444",
            borderRadius: 12, padding: 28, maxWidth: 360, width: "90%"
          }}>
            <h3 style={{ color: "#ef4444", margin: "0 0 8px" }}>
              Delete User?
            </h3>
            <p style={{ color: "#aaa", fontSize: 14, margin: "0 0 20px" }}>
              This permanently deletes <strong style={{ color: "#fff" }}>
                {user.name || user.phoneNumber}
              </strong> and all their data. This cannot be undone.
            </p>
            {error && (
              <p style={{
                color: "#ef4444", fontSize: 13,
                background: "#2a0a0a", borderRadius: 6,
                padding: "8px 12px", margin: "0 0 16px"
              }}>
                {error}
              </p>
            )}
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button
                onClick={() => { setShowConfirm(false); setError(""); }}
                disabled={loading}
                style={{
                  padding: "8px 18px", borderRadius: 6,
                  background: "#2a2a2a", border: "1px solid #444",
                  color: "#ccc", cursor: "pointer", fontSize: 14
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                disabled={loading}
                style={{
                  padding: "8px 18px", borderRadius: 6,
                  background: "#ef4444", border: "none",
                  color: "#fff", cursor: "pointer", fontSize: 14,
                  opacity: loading ? 0.6 : 1
                }}
              >
                {loading ? "Deleting…" : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
